import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';


@Component({
  selector: 'tog-app-features-form',
  templateUrl: './app-features-form.component.html',
  styleUrls: ['./app-features-form.component.scss']
})
export class AppFeaturesFormComponent implements OnInit, OnDestroy {
  formChangeSubscription: Subscription;
  features: any[] = [];

  constructor(private _ab: AppBuilderService) {}

  ngOnInit() {
    this.features = this._ab.defaultFeatures;
  }

  featureToggled(sysName: any) {
    this._ab.toggleFeature(sysName);
  }

  get selectedFeatures(): any[] {
    return this._ab.selectedFeatures;
  }

  removeFeature(feature: any) {
    this._ab.removeFeature(feature);
  }

  ngOnDestroy() {
    if (this.formChangeSubscription) this.formChangeSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/forms/components/app-features-form/app-features-form.component.ts